import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATES_UNCONFIRMED = Symbol('affiliates.unconfirmed');

export const AFFILIATES_UNCONFIRMED_ROUTE_NAME = Symbol('affiliates.unconfirmed');
export const AFFILIATES_UNCONFIRMED_LIST_ROUTE_NAME = Symbol('affiliates.unconfirmed.list');

export const AFFILIATES_UNCONFIRMED_LIST_URL = 'admin/affiliates/list_unconfirmed';
export const AFFILIATES_UNCONFIRMED_LIST_QUERY_KEY = 'affiliates.unconfirmed.list';

export const AFFILIATES_UNCONFIRMED_SEND_EMAIL_URL = 'admin/affiliates/:id/resend_confirmation_email';
export const AFFILIATES_UNCONFIRMED_SEND_EMAIL_MUTATION_KEY = 'affiliates.unconfirmed.send-email';

export const AFFILIATES_UNCONFIRMED_GET_TOKEN_URL = 'admin/affiliates/:id/confirmation_token';
export const AFFILIATES_UNCONFIRMED_GET_TOKEN_QUERY_KEY = 'affiliates.unconfirmed.get-token';

export const AFFILIATES_UNCONFIRMED_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATES_UNCONFIRMED_EMAIL),
};
